import { successToast, errorToast } from '@/js/components/toast';

const init = () => {
  const $form = document.getElementById('contactForm');
  if (!$form) {
    return;
  }
  $form.addEventListener('onFormieSubmitError', (e) => {
    e.preventDefault();

    errorToast('The request encountered a network error. Please try again.', 7000);
  });
  $form.addEventListener('onAfterFormieSubmit', (e) => {
    e.preventDefault();

    successToast(e.detail?.submitActionMessage.replace(/<.*?>/g, '') || 'Message sent!', 10000);
  });
};

export default {
  init,
};
